import { CREATION_TRIGGER, MSG_FIELDS_OPTIONS } from "./product-constant";
import { IdNameObjectType } from "../../state/models/global-configuration-state.model";
import { AppScopeTrakingConfigurationInfo } from "./product.model";
import { FormGroup } from "@angular/forms";
import { ValidationContext } from "@cv-invision/cv.invision-views.ux";

const integrationAppScopeEnabled = function (control, jsonModelService: ValidationContext) {
	const appScopeEnabled = jsonModelService.FindValue('enabled');
	const nexsysEnabled = jsonModelService.FindRootValue('nexsys.enabled');
	const valutrustEnabled = jsonModelService.FindRootValue('valutrust.enabled');
	const xpanseEnabled = jsonModelService.FindRootValue('xpanse.enabled');
	const integrationEnabled = jsonModelService.FindRootValue('integration.enabled');

	return jsonModelService.IsEmpty() && (appScopeEnabled && (nexsysEnabled || valutrustEnabled || xpanseEnabled || integrationEnabled)) || false;
};

const appScopeIntegrationEnabled = function (control, jsonModelService: ValidationContext) {
	const appScopeEnabled = jsonModelService.FindValue('enabled');
	const nexsysEnabled = jsonModelService.FindRootValue('nexsys.enabled');
	const valutrustEnabled = jsonModelService.FindRootValue('valutrust.enabled');
	const xpanseEnabled = jsonModelService.FindRootValue('xpanse.enabled');
	const integrationEnabled = jsonModelService.FindRootValue('integration.enabled');
	return (appScopeEnabled && (nexsysEnabled || valutrustEnabled || xpanseEnabled || integrationEnabled));
}

export const APPSCOPE_FORM_CONFIG = {
	appScope: {
		enabled: {
			path: 'appscope.enabled',
			DataType: 'Boolean',
			DisplayText: `AppScope`,
			Name: 'enabled',
			customClass: 'product-form-switch ms-3',
			Visible: function (control, jsonModelService: ValidationContext) {
				const comparedValue = jsonModelService.FindRootValue('origin');
				return (comparedValue !== MSG_FIELDS_OPTIONS.ACUITY && comparedValue !== MSG_FIELDS_OPTIONS.CMPACUITY) || false;
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					const setAppScope = new AppScopeTrakingConfigurationInfo();
					if ($event.checked) {
						formGroup.get('appScope')?.setValue({ ...setAppScope, enabled: true });
					} else {
						formGroup.get('appScope')?.setValue({ ...setAppScope });
					}
					formGroup.get('appScope')?.updateValueAndValidity();
				},
			},
		},
		jobId: {
			DataType: 'Selector',
			path: 'jobId',
			UIControl: 'Dropdown',
			DisplayText: 'Job Name',
			label: 'Job Name',
			Name: 'appScope.jobId',
			customClass: 'product-form-dropdown',
			//required: false,
			options: [],
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			Disabled: function (control, jsonModelService) {
				return jsonModelService.FindValue('enabled') === false;
			},
			Visible: function (control, jsonModelService) {
				const comparedValue = jsonModelService.FindValue('enabled');
				return comparedValue || false;
			},
			isRequired: function (control, jsonModelService: any) {
				return jsonModelService.IsEmpty() && jsonModelService.FindValue('enabled');
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexJobOption = formConfigModel.options.findIndex(element => element.value === value);
						const jobOption = formConfigModel.options[indexJobOption];
						formGroup.get('appScope.jobName')?.setValue(jobOption.label);
					} else {
						formGroup.get('appScope.jobId')?.setValue(null);
						formGroup.get('appScope.jobName')?.setValue(null);
					}
					formGroup.get('appScope')?.updateValueAndValidity();
				},
			}
		},
		jobName: {
			DataType: 'String',
			path: 'appScope.jobName',
			DisplayText: 'Select an Job Name',
			label: 'Select an Job Name',
			Name: 'jobName',
			hidden: true,
			required: false,
		},
		invoice: {
			path: 'appScope.invoice',
			DataType: 'Boolean',
			DisplayText: `Invoice`,
			Name: 'invoice',
			customClass: 'product-form-switch ms-5 mt-4',
			required: false,
			Visible: function (control, jsonModelService) {
				const comparedValue = jsonModelService.FindValue('enabled');
				return comparedValue || false;
			}
		},
		creationTrigger: {
			DataType: 'Selector',
			path: 'appScope.creationTrigger',
			UIControl: 'Dropdown',
			DisplayText: 'Creation Trigger:(Select when the order must be created)',
			label: 'Creation Trigger:(Select when the order must be created)',
			Name: 'creationTrigger',
			customClass: 'product-form-dropdown',
			isRequired: function (control, jsonModelService) {
				const appScopeEnabled = jsonModelService.FindValue('enabled');
				return jsonModelService.IsEmpty() && appScopeEnabled;
			},
			Disabled: function (control, jsonModelService) {
				const acuityEnabled = jsonModelService.FindRootValue('acuity.enabled');
				return acuityEnabled === false;
			},
			Visible: function (control, jsonModelService: ValidationContext) {
				const appScopeEnabled = jsonModelService.FindValue('enabled');
				return appScopeEnabled || false;
			},
			options: CREATION_TRIGGER.map((item: IdNameObjectType) => {
				return {
					label: item.name,
					value: item.id,
				};
			}),
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
		},
		creationStatusTrigger: {
			DataType: 'Selector',
			path: 'appScope.creationStatusTrigger',
			UIControl: 'Dropdown',
			DisplayText: 'MileStone',
			label: 'MileStone',
			Name: 'creationStatusTrigger',
			customClass: 'product-form-dropdown',
			options: [],
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			Visible: function (control, jsonModelService: ValidationContext) {
				const creationTriggerValue = jsonModelService.FindValue('creationTrigger');
				return (creationTriggerValue === 'StatusChanged') || false;
			},
			isRequired: function (control, jsonModelService) {
				const creationTriggerValue = jsonModelService.FindValue('creationTrigger');
				return jsonModelService.IsEmpty() && (creationTriggerValue === 'StatusChanged') || false;
			}
		},
		productAssetDescription: {
			DataType: 'String',
			path: 'appScope.productAssetDescription ',
			DisplayText: '',
			label: '',
			Name: 'productAssetDescription ',
			hidden: true,
			required: false,
		},
		productAssetsId: {
			DataType: 'Selector',
			path: 'appScope.productAssetsId',
			UIControl: 'Dropdown',
			DisplayText: 'Assets on Completion',
			label: 'Assets on Completion',
			Name: 'productAssetsId',
			customClass: 'product-form-dropdown',
			options: [],
			required: false,
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			Visible: appScopeIntegrationEnabled,
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexOption = formConfigModel.options.findIndex(element => element.value === value);
						const option = formConfigModel.options[indexOption];
						formGroup.get('appScope.productAssetDescription')?.setValue(option.label);
					} else {
						formGroup.get('appScope.productAssetsId')?.setValue(null);
						formGroup.get('appScope.productAssetDescription')?.setValue(null);
					}
					formGroup.get('appScope')?.updateValueAndValidity();
				},
			}
		},
		disableCommunications: {
			path: 'appScope.disableCommunications',
			DataType: 'Boolean',
			DisplayText: `Disable AppScope communication with the provider`,
			Name: 'disableCommunications',
			customClass: 'product-form-switch ms-5 mt-4 mb-4',
			Visible: appScopeIntegrationEnabled,
			required: false,
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					formGroup.get('appScope.enqueueCommunications')?.setValue(false);
					if (formGroup.get('appScope.disableCommunications')?.value) {
						formGroup.get('appScope.enqueueCommunications')?.setValue(false);
					}

					formGroup.get('appScope')?.updateValueAndValidity();
				},
			},
		},
		enqueueCommunications: {
			path: 'appScope.enqueueCommunications',
			DataType: 'Boolean',
			DisplayText: `Enqueue Provider Event(until the associated provider order is received)`,
			Name: 'enqueueCommunications',
			customClass: 'product-form-switch ms-5 mb-4',
			required: false,
			Visible: function (control, jsonModelService: ValidationContext) {
				const appScopeIntegrationEnable = appScopeIntegrationEnabled;
				const creationTriggerValue = jsonModelService.FindValue('creationTrigger');

				return appScopeIntegrationEnable && creationTriggerValue === 'StatusChanged';
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					formGroup.get('appScope.disableCommunications')?.setValue(false);

					if (formGroup.get('appScope.enqueueCommunications')?.value) {
						formGroup.get('appScope.disableCommunications')?.setValue(false);
					}
					formGroup.get('appScope')?.updateValueAndValidity();
				},
			},
		},
		borrowerEmailToComments: {
			path: 'appScope.borrowerEmailToComments',
			DataType: 'Boolean',
			DisplayText: `Borrower Email to Additional Comments`,
			Name: 'borrowerEmailToComments',
			customClass: 'product-form-switch ms-5',
			Visible: appScopeIntegrationEnabled,
			required: false
		},
		associatedOrderProductType: {
			DataType: 'Selector',
			path: 'appScope.associatedOrderProductType',
			UIControl: 'Dropdown',
			DisplayText: 'Associated Product',
			label: 'Associated Product',
			Name: 'associatedOrderProductType',
			customClass: 'product-form-dropdown',
			options: [],
			required: false,
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			Visible: function (control, jsonModelService: ValidationContext) {
				const appScopeEnqueueCommunicationEnabled = jsonModelService.FindValue('enqueueCommunications');
				const nexsysEnabled = jsonModelService.FindRootValue('nexsys.enabled');
				const valutrustEnabled = jsonModelService.FindRootValue('valutrust.enabled');
				const xpanseEnabled = jsonModelService.FindRootValue('xpanse.enabled');
				const integrationEnabled = jsonModelService.FindRootValue('integration.enabled');

				return (appScopeEnqueueCommunicationEnabled && (nexsysEnabled || valutrustEnabled || xpanseEnabled || integrationEnabled)) || false;
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexOrderProductName = formConfigModel.options.findIndex(element => element.value === value);
						const orderProduct = formConfigModel.options[indexOrderProductName];
						formGroup.get('appScope.associatedOrderProductName')?.setValue(orderProduct.label);
					} else {
						formGroup.get('appScope.associatedOrderProductType')?.setValue(null);
						formGroup.get('appScope.associatedOrderProductName')?.setValue(null);
					}
					formGroup.get('appScope')?.updateValueAndValidity();
				},
			},
		},
		associatedOrderProductName: {
			DataType: 'String',
			path: 'appScope.associatedOrderProductName',
			DisplayText: 'Select an Job Name',
			label: 'Select an Job Name',
			Name: 'associatedOrderProductName',
			hidden: true,
			required: false,
		},
		enableAcuityFileSincronization: {
			path: 'appScope.enableAcuityFileSincronization',
			DataType: 'Boolean',
			DisplayText: `File synchronization with Acuity`,
			Name: 'enableAcuityFileSincronization',
			customClass: 'product-form-switch ms-5 mb-4',
			required: false,
			UIOptions: {
				showLabel: true,
				SwitchComponentOptions: {
					removeLinkLabel: true,
				},
			},
			Visible: function (control, jsonModelService: ValidationContext) {
				const appScopeOrigin = jsonModelService.FindRootValue('origin');
				return (appScopeOrigin === MSG_FIELDS_OPTIONS.APPSCOPE) || false;
			},
		}
	}
};
